import { logUsage, PerformanceDatapoint } from 'owa-analytics';
import type { RoomPanelMetricInfo } from '../store/schema/RoomPanelMetricTypes';
import { resetRoomPanelMetricsStore } from '../mutators/roomPanelMetricsMutators';

export default function logRoomPanelMetric(metric: RoomPanelMetricInfo) {
    resetRoomPanelMetricsStore();
    logUsage(
        'RoomPanelUsage',
        {
            ...metric,
        },
        {
            isCore: true,
        }
    );
}

export function getAvgRoomSelectedPerfData(
    perfDatapoint: PerformanceDatapoint,
    checkmarkName: string
) {
    if (perfDatapoint.waterfallTimings?.[checkmarkName]) {
        const RoomSelectedCheckmarks = Object.keys(perfDatapoint.waterfallTimings).filter(
            checkmark => checkmark.indexOf(checkmarkName) >= 0
        );
        let timeToSelectRoom = 0;
        RoomSelectedCheckmarks.forEach(key => {
            timeToSelectRoom += perfDatapoint.waterfallTimings[key];
        });
        timeToSelectRoom /= RoomSelectedCheckmarks.length;
        perfDatapoint.addCustomData({ AvgTimeToSelectRoom: timeToSelectRoom });
    }
}
